<template>
	<div>
		<ui-card
			icon="fal fa-cabinet-filing"
			title="Limites de Armazenamento"
			text='Defina o tamanho máximo para os arquivos de seu sistema. <br> <small>*Inclua "-1" para valor ilimitado.</small>'
			:obs="obs"
		>
			<template #body>
				<ui-load-success
					v-if="loader.overlay"
					:loading="loader.overlayLoading"
					:success="loader.overlaySucess"
				/>

				<div class="area-card">
					<transition name="fade">
						<div v-show="loader.body" class="loading-card">
							<ui-load-indicator
								bgColor="#e7e9f4"
								color="#69D296"
								:h="50"
								:stroke="8"
							/>
						</div>
					</transition>

					<div class="ui-table">
						<table>
							<thead>
								<tr>
									<th id="groups">Grupos</th>
									<th id="limits">Limite de Armazenamento</th>
									<th id="max">Máximo Upload</th>
								</tr>
							</thead>

							<tbody>
								<tr
									v-for="(group, index) in form.groups"
									:key="`${group}-${index}`"
								>
									<td>
										<div>{{ getUserT(group) }}</div>
									</td>
									<td>
										<ui-input
											group="MB"
											v-model="form.maxDiskSize[index]"
											:mask="mask.numbers"
										/>
									</td>
									<td>
										<ui-input
											group="MB"
											v-model="form.maxUploadSize[index]"
											:mask="mask.numbers"
										/>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</template>
			<template #fl></template>
			<template #fr>
				<ui-button type="submit" design="md success" :disabled="!canSubmit" @click="submit"
					>Salvar</ui-button
				>
			</template>
		</ui-card>
	</div>
</template>

<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiInput } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	import { storage } from '@/services/storage'

	const defaultForm = () => ({
		groups: ['admin', 'collaborator', 'supervisor', 'manager', 'broker'],
		maxDiskSize: ['', '', '', '', ''],
		maxUploadSize: ['', '', '', '', ''],
	})

	const defaultMask = () => ({
		numbers: {
			mask: '09999',
			tokens: {
				0: {
					pattern: new RegExp('-|[0-9]'),
					transform: (v) => v,
				},
				9: {
					pattern: new RegExp('[0-9]'),
					transform: (v) => v,
				},
			},
		},
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		components: {
			uiCard,
			uiInput,
			uiButton,
			uiLoadSuccess,
			uiLoadIndicator,
		},

		data() {
			return {
				form: { ...defaultForm() },
				loader: { ...defaultLoader() },
				configFiles: {},
				oldForm: {},
				mask: { ...defaultMask() },
			}
		},

		mixins: [utilMixin, formMixin, alertMixin],

		async created() {
			this.loader.body = true
			this.configFiles = await this.getConfig('configFiles', 'value_long')
			this.form.groups = this.configFiles.groups
			this.form.maxDiskSize = this.configFiles.maxDiskSize
			this.form.maxUploadSize = this.configFiles.maxUploadSize

			setTimeout(() => {
				this.loader.body = false
			}, 1000)

			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			validateData() {
				const form = this.$mx_copyObject(this.form)
				let mimeType = []
				for (let type in form) {
					if (form[type].check) mimeType.push(...form[type].data)
				}
				return mimeType
			},

			obs() {
				if (this.configFiles.maxGeneralDisk)
					return `Limite máximo de armazenamento incluso no seu plano: <strong>${this.configFiles.maxGeneralDisk} MB</strong>`
				else return 'Carregando o limite armazenamento incluso no seu plano...'
			},
		},

		methods: {
			getConfig,
			saveConfig,

			getUserT(type) {
				return storage.get(`label_${type}`)
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					const configFiles = this.$mx_copyObject(this.configFiles)
					configFiles.maxDiskSize = this.form.maxDiskSize
					configFiles.maxUploadSize = this.form.maxUploadSize

					await this.saveConfig('configFiles', configFiles, 'value_long')

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
